import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';


export class Categorieslist{
  constructor(){}
  public categoryId : number;
  public category : string;
}

@Injectable({
  providedIn: 'root'
})

export class CategoriesService {
  
  
  constructor(private httpClient:HttpClient) { }

  /**
   * getsectorsList
   */
  public getCategoriesList() {
    return this.httpClient.get<Categorieslist[]>('api/v1/category/');
  }

  
  public createCategory(obj : any) : Observable<any>{
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<any>('/api/v1/category/' , obj , {headers}).pipe(catchError(this.errorHandler));
  }

  updateCategory(bean: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put<any>('/api/v1/category/' , bean , {headers}).pipe(catchError(this.errorHandler));
  }

  public deleteCategory(Id: number){
    return this.httpClient.delete('api/v1/category/' + Id);
  }

  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }

}
